import { PreferredAttendanceMethod } from "../types/PreferredAttendanceMethod";
import IConcessionCard from "./IConcessionCard";
import IMedicareCard from "./IMedicareCard";
import IStudentCard from "./IStudentCard";

export default interface IAppointmentBookingRequest {
	appointmentTypeId: number;
	doctorId: number;
	organisationId: number;
	branchId: number;
	givenName: string;
	middleName?: string;
	familyName: string;
	mobileNumber: string;
	email?: string;
	dateOfBirth: string;
	appointmentDate: string;
	appointmentStartTime: string;
	reason: string;
	preferredAttendanceMethod: PreferredAttendanceMethod;
	medicareCard?: IMedicareCard;
	concessionCard?: IConcessionCard;
	studentCard?: IStudentCard;
	sex: string;
}

export const InitialAppointmentBookingRequestState: IAppointmentBookingRequest = {
	appointmentTypeId: 0,
	doctorId: 0,
	organisationId: 1,
	branchId: 1,
	givenName: "",
	familyName: "",
	mobileNumber: "",
	dateOfBirth: "",
	appointmentDate: "",
	appointmentStartTime: "",
	reason: "",
	preferredAttendanceMethod: "ONSITE",
	sex: "",
};
